import { create } from 'zustand';
import { FeatureStore } from '../types/featureStore';
import { createJSONStorage, persist } from 'zustand/middleware';
import { zustandFF4JStorage } from './mmkvFF4J';

export const useFF4JStore = create<FeatureStore>()(
  persist(
    (set, get) => ({
      flags: {},
      setFlag: (key, value) => set((state) => ({ flags: { ...state.flags, [key]: value } })),
      setAllFlags: (flags) => set(() => ({ flags })),
      reset: () => set(() => ({ flags: {} })),
    }),
    {
      name: 'ff4jStorage',
      storage: createJSONStorage(() => zustandFF4JStorage),
    }
  )
);
